import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { EnvWrapper } from './context/env.context';

// Gán window.name (nếu chưa có)
if (!window.name) {
    window.name = crypto.randomUUID();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <GoogleOAuthProvider
            // clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
            // Test for firebase web app domain mymusic-social.web.app
            clientId="399223275562-ora13ihmeq65igmc1hp4u5v042f1adus.apps.googleusercontent.com"
        >
            <EnvWrapper>
                <App />
            </EnvWrapper>
        </GoogleOAuthProvider>
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
